import React from 'react';
import { connect } from 'react-redux';

import BaseLayout from 'apps/auth/components/common/Layout/BaseLayout';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import BasePage from 'apps/auth/components/utils/BasePage';
import { AUTH_PROFILE_FIELDS } from 'apps/auth/constants/UrlConstants';

const PhoneNumberUpdatedPage = (props) => {
    return (
        <BaseLayout showChat={false}>
            <InfoPage
                backUrl={AUTH_PROFILE_FIELDS}
                animatedIconSuccess
                headerText={props.profileUpdatedHeader}
                secondaryText={props.profileNewPhone}
                primaryButtonType="reactLink"
                primaryButtonCaption={props.profileDone}
                primaryButtonLink={AUTH_PROFILE_FIELDS}
            />
        </BaseLayout>
    );
};
const mapStateToProps = (state) => {
    return {
        profileUpdatedHeader: state.messages.pageMessages.profileUpdatedHeader,
        profileNewPhone: state.messages.pageMessages.profileNewPhone,
        profileDone: state.messages.pageMessages.profileDone,
    };
};
export default connect(mapStateToProps, null)(BasePage(PhoneNumberUpdatedPage));
